// Validation untuk Login, Register dan Lupa Password
import moment from "moment";
const datenow = moment().format("YYYY-MM-DD");

export const ValProfile = async (data, tab) => {
  const errors = [];

  if (tab === 1) {
    if (!data.first_name) {
      errors.push({
        type: "first_name",
        message: "nama depan tidak boleh kosong",
      });
    } else if (!/^[A-Za-z]+$/.test(data.first_name)) {
      errors.push({
        type: "first_name",
        message: "nama depan hanya mengandung alphabet",
      });
    }

    if (data.last_name) {
      if (!/^[A-Za-z]+$/.test(data.last_name)) {
        errors.push({
          type: "last_name",
          message: "nama belakang hanya mengandung alphabet",
        });
      }
    }

    if (
      !/^[0-9]*$/.test(data.no_hp) ||
      data.no_hp.length < 11 ||
      data.no_hp.length > 13
    ) {
      errors.push({
        type: "no_hp",
        message: "nomor telepon tidak sesuai format",
      });
    }

    if (data.gender === 0) {
      errors.push({
        type: "gender",
        message: "gender tidak boleh kosong",
      });
    }

    if (!data.tempat_lahir) {
      errors.push({
        type: "tempat_lahir",
        message: "tempat lahir tidak boleh kosong",
      });
    }

    if (!data.tgl_lahir) {
      errors.push({
        type: "tgl_lahir",
        message: "tanggal lahir tidak boleh kosong",
      });
    } else if (data.tgl_lahir) {
      if (!moment(data.tgl_lahir.toString()).isBefore(datenow, "day")) {
        if (!moment(data.tgl_lahir.toString()).isSame(datenow, "day"))
          errors.push({
            type: "tgl_lahir",
            message: "tanggal lahir tidak boleh memilih hari besok",
          });
      }
    }
  } else if (tab === 0) {
    if (!data.alamat) {
      errors.push({
        type: "alamat",
        message: "alamat tidak boleh kosong",
      });
    } else if (data.alamat > 255) {
      errors.push({
        type: "alamat",
        message: "alamat terlalu panjang",
      });
    }

    if (!data.provinsi) {
      errors.push({
        type: "provinsi",
        message: "provinsi tidak boleh kosong",
      });
    }

    if (!data.kota) {
      errors.push({
        type: "kota",
        message: "kota tidak boleh kosong",
      });
    }

    if (!data.kecamatan) {
      errors.push({
        type: "kecamatan",
        message: "kecamatan tidak boleh kosong",
      });
    }

    if (!data.kelurahan) {
      errors.push({
        type: "kelurahan",
        message: "kelurahan tidak boleh kosong",
      });
    }

    if (!data.kodepos) {
      errors.push({
        type: "kodepos",
        message: "kode pos tidak boleh kosong",
      });
    }

    if (!data.tempat_lahir) {
      errors.push({
        type: "tempat_lahir",
        message: "tempat lahir tidak boleh kosong",
      });
    }

    if (!data.tgl_lahir) {
      errors.push({
        type: "tgl_lahir",
        message: "tanggal lahir tidak boleh kosong",
      });
    }
  }

  return errors;
};

export const ValPassword = async (data, isCheck) => {
  const errors = [];

  if (!data.password_lama) {
    errors.push({
      type: "password_lama",
      message: "password tidak boleh kosong",
    });
  } else if (
    // !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/.test(
    //   data.password_lama
    // )
    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/.test(
      data.password_lama
    )
  ) {
    errors.push({
      type: "password_lama",
      message: "Password harus huruf besar, kecil, dan minimal 8 karakter",
    });
  }

  if (!isCheck) {
    if (!data.password_baru) {
      errors.push({
        type: "password_baru",
        message: "password baru tidak boleh kosong",
      });
    } else if (
      // !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/.test(
      //   data.password_baru
      // )
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/.test(
        data.password_baru
      )
    ) {
      errors.push({
        type: "password_baru",
        message: "Password harus huruf besar, kecil, dan minimal 8 karakter",
      });
    } else if (data.c_password_baru !== data.password_baru) {
      errors.push({
        type: "c_password_baru",
        message: "konfirmasi password harus sama dengan password baru",
      });
    }
  }

  return errors;
};
